module.exports = __webpack_public_path__ + "img/orgCertBanner.97b0c6a3.png";